module.exports = __webpack_public_path__ + "img/result_icon.75c358ba.png";